<form [formGroup]="planSettingsService.planSettingsForm">
  <div *ngIf="plan">
    <efp-list-header [topPadding]="false">
      <ion-label>{{ 'SETTINGS.PLAN_SETTINGS' | translate }}</ion-label>
    </efp-list-header>
    <div class="flex flex-col gap-md">
      <doka-text-field
        [alert]="
          planName?.dirty && planName?.invalid ? ('PLAN.NAME_ERROR_MESSAGE' | translate) : ''
        "
        [label]="'PLAN.NAME' | translate"
        formControlName="planName"
        data-test-selector="plansettings-name"
        (valueChange)="changeName()"
        [placeholder]="'PLAN.NAME' | translate"
        efpInputKeyboard>
      </doka-text-field>
      <doka-select
        [label]="'PLAN.BUILDING_TYPE' | translate"
        [required]="true"
        formControlName="buildType"
        [placeholder]="'PLAN.BUILDING_TYPE_SELECT' | translate">
        <doka-select-option
          *ngFor="let type of planType | keyvalue"
          [value]="type.value"
          [label]="'PLAN.' + type.value | translate"></doka-select-option>
      </doka-select>

      <doka-select
        *ngIf="projects$ | async as projects"
        [label]="'PLAN.PROJECT' | translate"
        formControlName="projectId">
        <doka-select-option
          *ngFor="let project of projects"
          [value]="project.id"
          [label]="
            project.name != 'default' ? project.name : ('PROJECT.UNASSIGNED_PROJECTS' | translate)
          "></doka-select-option>
      </doka-select>

      <doka-select
        *ngIf="filteredStocks$ | async as stocks"
        [label]="'PLAN.STOCK' | translate"
        formControlName="stockId"
        [placeholder]="'PLAN.STOCK_SELECT' | translate">
        <doka-select-option
          [value]="NO_STOCK_SELECTED"
          [label]="'PLAN.NO_STOCK' | translate"></doka-select-option>
        <doka-select-option
          *ngFor="let stock of stocks"
          [value]="stock.id"
          [label]="stock.name"></doka-select-option>
      </doka-select>
    </div>
  </div>
</form>
